import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ProfilePreviewWrapper } from "../../Dashboard/ProfilePage/style";
import ProfileHeader from "../../Dashboard/ProfilePage/ProfileHeader";
import ContextDashboard from "../../../Context/ContextDashboard";
import { getStorage, setStorage } from "../../../Utils/common";
import { getDashboardData, orderId } from "../../../Utils/api";
import PaymentModal from "../../../components/Payment/PaymentModal";
import { useNavigate } from "react-router-dom";
import logo from "../../../images/logo_bg.jpeg";

function RepayPage(props) {
  const [content, setContent] = useState("pannumber");
  const [getLoading, setLoading] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState("");
  const { outdata, logout } = useContext(ContextDashboard);
  const [repayData, setRepayData] = useState("");
  const [order, setOrder] = useState("");
  const [paymentAmount, setPaymentAmount] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    const params = {
      profile_id: getStorage("cust_profile_id") || "",
    };

    getDashboardData(params).then((resp) => {
      if (resp?.data?.Status === 1) {
        const dashboardData = resp?.data || {};
        setStorage("dashboardData", dashboardData);
        setRepayData(dashboardData);
        if (dashboardData) {
          const param = {
            lead_id: dashboardData?.Data?.active_loan_details?.lead_id,
            rzp_amount: dashboardData?.Data?.active_loan_details?.total_due,
          };
          orderId(param).then((resp) => {
            if (resp?.data?.Status === 1) {
              const orderData = resp?.data || {};
              setOrder(orderData);
            }
          });
        }
      }
    });
  }, []);

  const payHere = async () => {
    setLoading(true);
    try {
      const total_due_amount =
        paymentAmount || repayData?.Data?.active_loan_details?.total_due;
      const options = {
        key: "",
        amount: (total_due_amount * 100).toString(),
        currency: "INR",
        name: "Speedoloan",
        image: logo,
        order_id: order?.Data?.order_id,
        // callback_url: "https://salaryontime.in/thankyou",
        prefill: {
          name: repayData?.Data?.profile_details?.first_name,
          email: repayData?.Data?.profile_details?.cp_personal_email,
          contact: repayData?.Data?.profile_details?.cp_mobile,
        },
        theme: { color: "#4FA0FF" },
        handler: function (response) {
          // Callback function when payment is successful
          const paymentDetails = {
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_order_id: response.razorpay_order_id,
            razorpay_signature: response.razorpay_signature,
          };

          fetch("URL", {
            method: "POST",
            headers: {
              "Content-Type": "application/json; charset=UTF-8",
              Auth: "",
              Accept: "application/json",
            },
            body: JSON.stringify(paymentDetails),
          })
            .then((res) => res.json())
            .then((data) => {
              let txnStatus = data.status;
              let txnId = data.txnId || "N/A";

              // Pass txnStatus and txnId to the thank you page using navigate
              navigate("/thanku", {
                state: {
                  txnStatus: txnStatus,
                  txnId: txnId,
                },
              });

              setPaymentStatus(
                txnStatus === "SUCCESS"
                  ? "Payment Successful"
                  : "Payment Verification Failed",
              );
              setContent(
                txnStatus === "SUCCESS" ? "paymentSuccess" : "paymentFailure",
              );
              setLoading(false);
            })
            .catch((error) => {
              console.error("Error verifying payment:", error);
              setPaymentStatus("Payment Verification Failed");
              setLoading(false);
            });
        },
      };

      const res = await loadScript("");
      if (res) {
        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
      } else {
        alert("Razorpay SDK failed to load. Are you online?");
      }
    } catch (error) {
      console.error("Error during payment:", error);
      setLoading(false);
    }
  };

  let processing = false; // Define the flag outside the function scope

  const payWithPayU = async () => {
    if (processing) return; // Prevent function from running if already in process
    processing = true;

    setLoading(true);
    try {
      const total_due_amount =
        paymentAmount || repayData?.Data?.active_loan_details?.total_due;
      // const total_due_amount = 1;
      const MERCHANT_KEY = "LrvBUp";
      const productinfo = "Loan repayment for Loan No";
      const fullname = repayData?.Data?.profile_details?.first_name;
      const email = repayData?.Data?.profile_details?.personal_email;
      const phone = repayData?.Data?.profile_details?.mobile;

      const response = await fetch("", {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Accept: "application/json",
          Auth: "",
        },
        body: JSON.stringify({
          amount: total_due_amount,
          productinfo: productinfo,
          firstname: fullname,
          email: email,
          mobile: phone,
          udf5: repayData?.Data?.active_loan_details?.lead_id,
        }),
      });

      const data = await response.json();

      if (data.Status === 1) {
        const hashData = data.data.parameters;

        const payuOptions = {
          key: MERCHANT_KEY,
          txnid: hashData.txnid,
          amount: total_due_amount,
          productinfo: productinfo,
          firstname: fullname,
          email: email,
          phone: phone,
          surl: "https://salaryontime.com/thanku",
          furl: "https://salaryontime.com/thanku",
          hash: hashData.hash,
          udf5: repayData?.Data?.active_loan_details?.lead_id,
        };

        const scriptLoaded = await loadScript(
          "https://jssdk.payu.in/bolt/bolt.min.js",
        );

        if (scriptLoaded) {
          if (typeof window.bolt !== "undefined") {
            window.bolt.launch(payuOptions, {
              responseHandler: function (BOLT) {
                if (BOLT.response.txnStatus === "SUCCESS") {
                  // Pass the transaction status to the Thank You page via React Router's state
                  navigate("/thanku", {
                    state: {
                      txnStatus: BOLT.response.txnStatus,
                      txnId: BOLT.response.txnid,
                    },
                  });
                }
                if (
                  BOLT.response.txnStatus === "FAILED" ||
                  BOLT.response.txnStatus === "CANCEL"
                ) {
                  navigate("/thanku", {
                    state: {
                      txnStatus: BOLT.response.txnStatus,
                      txnId: BOLT.response.txnid,
                    },
                  });
                }
              },
              catchException: function (BOLT) {
                console.log("Payment failed. Please try again.");
              },
            });
          } else {
            console.error("PayU SDK not initialized correctly after loading.");
          }
        } else {
          console.error("Failed to load PayU script.");
        }
      } else {
        console.error("Failed to get valid response from PayU API.");
      }
    } catch (error) {
      console.error("Error during PayU payment:", error);
    } finally {
      setLoading(false);
      processing = false;
    }
  };

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handlePaymentClick = () => {
    setModalOpen(true);
    setLoading(false);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleRazorpay = () => {
    setModalOpen(false);
    payHere();
    setLoading(false);
  };

  const handlePayU = () => {
    setModalOpen(false);
    payWithPayU();
    setLoading(false);
  };
  const handlePaymentAmountChange = (e) => {
    let value = e.target.value;

    // Prevent the value from starting with 0, but allow decimal numbers
    if (value.length === 1 && value === "0") {
      // Do nothing if the input is just "0"
      return;
    }

    // Regex to ensure the input doesn't start with a "0" unless it's "0." (i.e., decimal number like 0.50 is allowed)
    const regex = /^(?!0(\.\d+)?)(\d*\.?\d*)$/;

    // Only update if the value matches the regex pattern
    if (regex.test(value) || value === "") {
      setPaymentAmount(value);
    }
  };

  return (
    <ProfilePreviewWrapper>
      <ProfileHeader />
      <br />

      {/* <div className="repayment-card">
        <div className="repayment-header">
          <h2 style={{ color: "#1D3557" }}>Loan Repayment Details</h2>
        </div>

        <div className="repayment-info">
          <div className="info-item">
            <span className="label" style={{ color: "#1D3557" }}>
              Loan Number:
            </span>
            <span className="value" style={{ color: "#1D3557" }}>
              {repayData?.Data?.active_loan_details?.loan_no}
            </span>
          </div>
          <div className="info-item">
            <span className="label" style={{ color: "#1D3557" }}>
              Disbursal Date:
            </span>
            <span className="value" style={{ color: "#1D3557" }}>
              {repayData?.Data?.active_loan_details?.disbursal_date}
            </span>
          </div>
          <div className="info-item">
            <span className="label" style={{ color: "#1D3557" }}>
              Repayment Date:
            </span>
            <span className="value" style={{ color: "#1D3557" }}>
              {repayData?.Data?.active_loan_details?.repayment_date}
            </span>
          </div>
          <div className="info-item">
            <span className="label" style={{ color: "#1D3557" }}>
              Repayment Amount:
            </span>
            <span className="value" style={{ color: "#1D3557" }}>
              ₹{repayData?.Data?.active_loan_details?.repayment_amount}
            </span>
          </div>
          <div className="info-item">
            <span className="label" style={{ color: "#1D3557" }}>
              Loan Amount:
            </span>
            <span className="value" style={{ color: "#1D3557" }}>
              ₹{repayData?.Data?.active_loan_details?.loan_recommended}
            </span>
          </div>
          <div className="info-item">
            <span className="label" style={{ color: "#1D3557" }}>
              Real Interest:
            </span>
            <span className="value" style={{ color: "#1D3557" }}>
              ₹{repayData?.Data?.active_loan_details?.roi}
            </span>
          </div>
          <div className="info-item">
            <span className="label" style={{ color: "#1D3557" }}>
              Repayment With Interest:
            </span>
            <span className="value" style={{ color: "#1D3557" }}>
              ₹{repayData?.Data?.active_loan_details?.total_due}
            </span>
          </div>
          <div className="info-item due-amount">
            <span
              className="label"
              style={{ color: "#1D3557", fontWeight: "bold" }}
            >
              Total Due Amount:
            </span>
            <span
              className="value"
              style={{ color: "#1D3557", fontWeight: "bold" }}
            >
              ₹{repayData?.Data?.active_loan_details?.total_due}
            </span>
          </div>
          <div className="info-item part-amount">
            <span className="label" style={{ color: "#1D3557" }}>
              Amount To Pay
            </span>
            {/* Make the Amount To Pay field editable */}
      {/* <input
              type="text"
              value={paymentAmount}
              onChange={handlePaymentAmountChange}
              placeholder="Enter payment amount"
              style={{ border: "1px solid #E5E5E5", color: "#1D3557" }}
            />
          </div>
        </div>

        <div className="repayment-button-container">  */}
      {/* <button className="repayment-button" onClick={handlePaymentClick} style={{ background: "#FFD700", color: "#1D3557" }}>
            {getLoading ? (
              <div className="loadinganim"></div>
            ) : (
              "Proceed to Pay"
            )}
          </button> */}
      {/* </div>

        {isModalOpen && (
          <PaymentModal
            onClose={handleCloseModal}
            // onRazorpay={handleRazorpay}
            // onPayU={handlePayU}
            isLoading={getLoading}
          />
        )}
      </div> */}

      <div className="w-full max-w-5xl mx-auto rounded-3xl bg-white shadow-lg border border-gray-200 p-5 sm:p-8">

        {/* Header */}
        <div className="border-b border-gray-200 pb-5 mb-6">
          <h2 className="text-2xl sm:text-3xl font-bold text-[#1D3557]">
            Loan Repayment Details
          </h2>
        </div>

        {/* Details */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

          <div className="flex justify-between border-b pb-3">
            <span className="font-medium text-gray-600">Loan Number</span>
            <span className="font-semibold text-[#1D3557]">
              {repayData?.Data?.active_loan_details?.loan_no}
            </span>
          </div>

          <div className="flex justify-between border-b pb-3">
            <span className="font-medium text-gray-600">Disbursal Date</span>
            <span className="font-semibold text-[#1D3557]">
              {repayData?.Data?.active_loan_details?.disbursal_date}
            </span>
          </div>

          <div className="flex justify-between border-b pb-3">
            <span className="font-medium text-gray-600">Repayment Date</span>
            <span className="font-semibold text-[#1D3557]">
              {repayData?.Data?.active_loan_details?.repayment_date}
            </span>
          </div>

          <div className="flex justify-between border-b pb-3">
            <span className="font-medium text-gray-600">Repayment Amount</span>
            <span className="font-semibold text-[#1D3557]">
              ₹{repayData?.Data?.active_loan_details?.repayment_amount}
            </span>
          </div>

          <div className="flex justify-between border-b pb-3">
            <span className="font-medium text-gray-600">Loan Amount</span>
            <span className="font-semibold text-[#1D3557]">
              ₹{repayData?.Data?.active_loan_details?.loan_recommended}
            </span>
          </div>

          <div className="flex justify-between border-b pb-3">
            <span className="font-medium text-gray-600">Real Interest</span>
            <span className="font-semibold text-[#1D3557]">
              ₹{repayData?.Data?.active_loan_details?.roi}
            </span>
          </div>

          <div className="flex justify-between border-b pb-3 md:col-span-2">
            <span className="font-medium text-gray-600">
              Repayment With Interest
            </span>

            <span className="font-semibold text-[#1D3557]">
              ₹{repayData?.Data?.active_loan_details?.total_due}
            </span>
          </div>

          {/* Total Due */}
          <div className="md:col-span-2 rounded-2xl bg-orange-50 border border-orange-200 p-5">

            <div className="flex justify-between items-center">

              <span className="text-lg font-bold text-[#1D3557]">
                Total Due Amount
              </span>

              <span className="text-2xl font-bold text-orange-600">
                ₹{repayData?.Data?.active_loan_details?.total_due}
              </span>

            </div>

          </div>

          {/* Amount to Pay */}
          <div className="md:col-span-2">

            <label className="block mb-2 font-semibold text-[#1D3557]">
              Amount To Pay
            </label>

            <input
              type="text"
              value={paymentAmount}
              onChange={handlePaymentAmountChange}
              placeholder="Enter payment amount"
              className="w-full rounded-xl border border-gray-300 px-4 py-3 text-[#1D3557] focus:border-[#2D5F7A] focus:ring-2 focus:ring-[#2D5F7A]/20 outline-none"
            />

          </div>

        </div>

        {/* Button */}
        <div className="mt-8">

          {/* <button
            onClick={handlePaymentClick}
            className="w-full rounded-xl bg-[#2D5F7A] py-3 text-white font-semibold hover:bg-[#23495E] transition"
          >
            {getLoading ? (
              <div className="flex justify-center">
                <div className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
              </div>
            ) : (
              "Proceed to Pay"
            )}
          </button> */}

        </div>

        {/* Payment Modal */}
        {isModalOpen && (
          <PaymentModal
            onClose={handleCloseModal}
            isLoading={getLoading}
          />
        )}

      </div>
    </ProfilePreviewWrapper>
  );
}

export default RepayPage;
